import { Check } from "lucide-react";

const PRESET_COLORS = [
  { hex: "#F43F5E", name: "Vermelho" },
  { hex: "#F97316", name: "Laranja" },
  { hex: "#F59E0B", name: "Âmbar" },
  { hex: "#10B981", name: "Verde" },
  { hex: "#06B6D4", name: "Ciano" },
  { hex: "#3B82F6", name: "Azul" },
  { hex: "#14B8A6", name: "Turquesa" },
  { hex: "#EC4899", name: "Rosa" },
];

type Props = {
  value: string;
  onChange: (color: string) => void;
  defaultColor?: string;
  disabled?: boolean;
};

export function ColorPickerField({
  value,
  onChange,
  defaultColor = "#F43F5E",
  disabled,
}: Props) {
  const current = value.toUpperCase();
  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-1.5">
        {PRESET_COLORS.map((preset) => {
          const active = preset.hex.toUpperCase() === current;
          return (
            <button
              key={preset.hex}
              type="button"
              onClick={() => onChange(preset.hex.toUpperCase())}
              disabled={disabled}
              title={preset.name}
              className={`relative flex h-10 w-10 items-center justify-center rounded-full transition-transform hover:scale-110 disabled:opacity-50 disabled:hover:scale-100 sm:h-8 sm:w-8 ${
                active ? "ring-2 ring-offset-2 ring-zinc-900" : ""
              }`}
              style={{ background: preset.hex }}
              aria-label={preset.name}
              aria-pressed={active}
            >
              {active && <Check className="h-4 w-4 text-white drop-shadow" />}
            </button>
          );
        })}
      </div>

      <div className="flex items-center gap-2">
        <label
          className="relative inline-flex h-10 w-10 cursor-pointer items-center justify-center overflow-hidden rounded-full ring-1 ring-zinc-200 transition-transform hover:scale-110 sm:h-8 sm:w-8"
          style={{ background: value }}
          title="Cor customizada"
        >
          <input
            type="color"
            value={value}
            onChange={(e) => onChange(e.target.value.toUpperCase())}
            disabled={disabled}
            className="absolute inset-0 cursor-pointer opacity-0"
            aria-label="Escolher cor customizada"
          />
          <span className="pointer-events-none text-[8px] font-bold text-white drop-shadow">
            +
          </span>
        </label>
        <code className="rounded bg-zinc-100 px-2 py-1 text-[10px] font-semibold uppercase text-zinc-600">
          {current}
        </code>
        {current !== defaultColor.toUpperCase() && (
          <button
            type="button"
            onClick={() => onChange(defaultColor.toUpperCase())}
            disabled={disabled}
            className="ml-auto text-[11px] font-medium text-zinc-500 hover:text-brand-700 disabled:opacity-50"
          >
            Restaurar
          </button>
        )}
      </div>
    </div>
  );
}
